import { FormatDate } from '../../scripts/date-functions';
export class DocumentTree {

    constructor(nodes: any, treeId: string = "jstree", searchBoxId: string = "docSearch", searchClearId: string = "searchClear") {

        //console.log(nodes, treeId, searchBoxId, searchClearId);
        treeId = '#' + treeId;
        searchBoxId = '#' + searchBoxId;
        searchClearId = '#' + searchClearId;

        $(searchBoxId).val('');
        $(treeId).jstree({
            "plugins": ["search", "wholerow"],
            "search": {
                "show_only_matches": true,
                "fuzzy": false
            },
            "types": {
                "folder": {
                    "icon": "fas fa-folder"
                },
                "file": {
                    "icon": "fas fa-file-alt"
                }
            },
            'core': {
                'data': nodes
            }
        });//end jstree

        //open the folder when clicking it (instead of having to target the small arrow)
        $(treeId).on('select_node.jstree', function (e, data) {
            data.instance.toggle_node(data.node);
        });

        $(treeId).on('changed.jstree', function (e, data) {
            //if selected node is not a directory
            if (data.node.original.type > 0) {

                if (data.node.original.type == 1 && !data.node.original.link.startsWith("https://researchtriangleinstitute.sharepoint.com")) { //PDF and not hosted on SharePoint
                    var modal = $('#view-document-modal');
                    modal.find('#filename').html(data.node.original.text);

                    modal.find('#document-iframe').attr('src', data.node.original.link);

                    //console.log(data.node.original.link);

                    modal.modal('show');
                }
                else { //just download it
                    var hiddenLink = $('#non-pdf-link');
                    hiddenLink.attr('href', data.node.original.link);
                    hiddenLink.attr('target', '_blank');
                    hiddenLink[0].click();

                }


            }
        });


        //do search on keyup
        $(searchBoxId).keyup(function () {
            var search = $(this).val();
            $(treeId).jstree('search', search);
        });

        //handle search clear button
        $(searchClearId).click(function () {
            $(searchBoxId).val('');
            $(treeId).jstree('search', '');
        });

    }
}

export class DocumentTreeV2 {
    jsTreeId: string;
    searchBoxId: string;
    searchClearId: string;

    constructor(nodes: any, treeId: string = "jstree", searchBoxId: string = "docSearch", searchClearId: string = "searchClear", callbackFn = () => { }) {

        //console.log(nodes);
        treeId = '#' + treeId;
        searchBoxId = '#' + searchBoxId;
        searchClearId = '#' + searchClearId;
        this.jsTreeId = treeId;
        this.searchBoxId = searchBoxId;
        this.searchClearId = searchClearId;

        $(searchBoxId).val('');

        // Run the callback function when the document tree is loaded
        $(treeId).on("loaded.jstree", () => {
            callbackFn();
        })

        $(treeId).jstree({
            "plugins": ["search", "wholerow"],
            "search": {
                "show_only_matches": true,
                "fuzzy": false,
                "search_callback": function (str, node) {
                    let compareTo: string = node.text.toLowerCase();
                    let checkStr: string = str.toLowerCase();

                    if (checkStr.includes("/")) {
                        compareTo = node.id.toLowerCase();
                    }

                    if (compareTo.includes(checkStr)) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            },
            "types": {
                "folder": {
                    "icon": "fas fa-folder"
                },
                "file": {
                    "icon": "fas fa-file-alt"
                }
            },
            'core': {
                'data': nodes
            }
        });//end jstree


        // When user clicks on a node in the tree 
        let fileTree = this;
        $(treeId).on('activate_node.jstree', function (e, data) {
            //if selected node is not a directory, open the file dialog box
            if (data.node.original.type > 0) {
                //fileTree.openModal(data);
            }
            // if selected node is a directory, toggle the open/close
            else {
                data.instance.toggle_node(data.node);
            }
        })

        $(treeId).on('select_node.jstree', (e, data) => {
            if (data.node.original.type > 0) {
                this.selectFile(data);
            }
            else {
                $(this.jsTreeId).find(".file-button-background").remove();
                $(this.jsTreeId).find(".file-button-content").remove();
            }
        });

        

        //do search on keyup
        $(searchBoxId).on("keyup", function () {
            var search = $(this).val();
            $(treeId).jstree('search', search);
        });

        //handle search clear button
        $(searchClearId).on("click", function () {
            $(searchBoxId).val('');
            $(treeId).jstree('search', '');
        });

    }

    openPdfModal(data: any): void {
        // Set Information for dialog box
        var modal = $('#view-document-modal');
        modal.find('#filename').html(data.node.original.text);

        // Add PDF View
        modal.find('#document-iframe').attr('src', data.node.original.link);
        modal.modal('show');

    }

    openCopyLinkModal(data: any): void {
        let modal = $("#share-document-modal");
        modal.find('#filename').html(data.node.original.text);

        let fileId = data.node.original.id;
        let urlBase = `${window.location.origin}${window.location.pathname}`;
        let copyUrl = `${urlBase}?filename="${encodeURIComponent(fileId)}"&searchid="${encodeURIComponent(this.searchBoxId.replace("#", ""))}"`;
        modal.find("#file-copy-id").val(copyUrl);

        modal.modal('show');
    }

    selectFile(data: any) {
        //console.log(data);
        let buttonContent = ""
        // if PDF or video, add the view button
        if (data.node.original.type == 1 || data.node.original.type == 6 || data.node.original.type == 5) {
            buttonContent += `
                <div class="pr-2">
                    <a class="file-btn py-2 font-size13 file-button-view" role="button">View <i class="fa-solid fa-magnifying-glass pl-1"></i></a>
                </div>
            `;
        }
        // URL (open in new tab)
        else if (data.node.original.type == 9) {
            buttonContent += `
                <div class="pr-2">
                    <a class="file-btn py-2 font-size13 file-button-download" href="${data.node.original.link}" target="_blank" role="button">View <i class="fa-solid fa-magnifying-glass pl-1"></i></a>
                </div>
            `;
        }
        // if not a PDF, add the download button
        else {
            buttonContent += `
                <div class="pr-2">
                    <a class="file-btn py-2 font-size13 file-button-download" href="${data.node.original.link}" download>Download <i class="fa-solid fa-file-arrow-down pl-1"></i></a>
                </div>
            `
        }

        // Always add copy button
        buttonContent += `
            <div class="pr-2">
                <a class="file-btn py-2 font-size13 file-button-copy"  role="button" >Share <i class="fa-solid fa-copy pl-1"></i></a>
            </div>
        `

        // if it is a collaborative document, display link to SP
        if (data.node.original.displaySpLink) {
            buttonContent += `
                <div class="pr-2">
                    <a class="file py-2 font-size13" href="${data.node.original.spLink}" target="_blank" role='button'>Edit in SharePoint <i class="fas fa-external-link-alt"></i></a>
                </div>
            `
        }

        let selectFileContent = `
            <div class='file-button-background'></div>
            <div class='file-button-content d-flex ml-5 align-items-center justify-content-between'>
                <div class='d-flex pl-1'>
                    ${buttonContent}
                </div>
                <div class='pr-3 file-last-modified-date-content'>
                    <div class='font-size13' style="line-height:20px; font-weight: 500"><u>Last Modified</u></div>
                    <div class='font-size13 text-right' style="line-height:20px;">${FormatDate(data.node.original.lastModifiedDate)}</div>
                </div>
            </div>
        
        `

        // remove any existing buttons
        $(this.jsTreeId).find(".file-button-background").remove();
        $(this.jsTreeId).find(".file-button-content").remove();

        // show the buttons for this file
        $(data.event.currentTarget).after(selectFileContent);

        $(this.jsTreeId).find(".file-button-view").on('click', () => {
            this.openPdfModal(data);
        });

        $(this.jsTreeId).find(".file-button-copy").on('click', () => {
            this.openCopyLinkModal(data);
        })
    }
}